import Component from '@glimmer/component';
import { notEq } from 'tio-ui/utilities';

interface TioStepOverviewSignature {
  Args: {
    steps: string[];
  };
  Element: HTMLDivElement;
}

export default class TioStepOverviewComponent extends Component<TioStepOverviewSignature> {
  add1(number: number) {
    return number + 1;
  }

  <template>
    <div ...attributes>
      <ol class="flex flex-col sm:flex-row flex-wrap sm:items-stretch w-full list-none">
        {{#each @steps as |step index|}}
          {{#if (notEq index 0)}}
            <li class="p-2 hidden sm:flex sm:float-left self-center">
              <svg
                width="33"
                height="14"
                viewBox="0 0 33 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32.3334 7.00004L25.6667 0.333374V5.33337H0.666687V8.66671H25.6667V13.6667L32.3334 7.00004Z"
                  fill="#5D219E"
                ></path>
              </svg>
            </li>
          {{/if}}
          <li class="sm:float-left h-auto py-2 sm:p-2">
            <span
              class="flex grid md:justify-items-center items-center grid-row grid-cols-5 grid-rows-1 sm:grid-col sm:grid-rows-2 sm:grid-cols-1 sm:w-40 h-full"
            >
              <div
                class="shrink-0 bg-white border-2 border-violet-800 text-violet-800 rounded-full leading-10 h-9 w-9 md:h-12 md:w-12 flex justify-center items-center"
              >
                <p class="text-xl font-semibold">
                  {{this.add1 index}}
                </p>
              </div>
              <div class="col-span-4 md:justify-self-center sm:pt-2 md:text-center">
                {{step}}
              </div>
            </span>
          </li>
        {{/each}}
      </ol>
    </div>
  </template>
}
